/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_BillingInputs */

const en_settings_nav_billing = /** @type {(inputs: Settings_Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

const zh_settings_nav_billing = /** @type {(inputs: Settings_Nav_BillingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账单`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Settings_Nav_BillingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_nav_billing = /** @type {((inputs?: Settings_Nav_BillingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_BillingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_nav_billing(inputs)
	return zh_settings_nav_billing(inputs)
});
export { settings_nav_billing as "settings.nav.billing" }